import {ListConfigs} from '../../app/sharedComponent/SearchList/SearchList.types'

export const QCUSERLISTCONFIGS: ListConfigs[] = [
  {
    headerName: 'QC Full Name',
    apiFieldName: 'qcName',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'QC Email ID',
    apiFieldName: 'emailId',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: '# Sales Channels',
    apiFieldName: 'noOfSalesChannel',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Successful TPVS',
    apiFieldName: 'noOfAcceptedTpvs',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Pending TPVS',
    apiFieldName: 'noOfPendingTpvs',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Sign In / Out Time',
    apiFieldNameFirst:'qcSignInTime',
    apiFieldNameSecond:'qcSignOutTime',
    columnWidth: '150',
    type: "LOCALTIME_SLASHSEPERATED",
  },
]
